/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import _ from 'lodash'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { Row, Col, Skeleton, Empty, Timeline, message, Popconfirm } from 'antd'
import { compose } from 'recompose'
import { Query, graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { RoleCode } from '../../constants'

import AddActionForm from './addActionForm'
import ViewAction from './viewActionDetails'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isActionFormShown: false,
			isViewActionShown: false,
			selectedComplainAction: null
		}
	}

	render() {
		const { isActionFormShown, isViewActionShown, selectedComplainAction } = this.state
		const { AuthStore, complain_uid, complain_status } = this.props
		const { user_type } = AuthStore
		const isAdmin = _.isEqual(RoleCode.SUPERADMIN, user_type) || _.isEqual(RoleCode.SYSTEMADMIN, user_type)

		return (
			<Query
				query={COMPLAIN_ACTIONS}
				variables={{ complain_uid }}
				fetchPolicy='network-only'
			>
				{({ loading, error, data }) => {
					if (loading) return <Skeleton active/>
					if (error) return <Empty />

					let complainActions = _.has(data,'barangayComplainActions') ? data.barangayComplainActions : []
					return (
						<Row style={{ marginTop: 50 }}>
							{
								//(!_.isEqual(complain_status, 'Settled') && 
								//!_.isEqual(complain_status, 'File to Action') &&
								//!_.isEqual(complain_status, 'Referral')) &&
								<Row type='flex' justify='center'>
									<button 
										type="button" 
										className="btn btn-primary btn-rounded waves-effect waves-light"
										onClick={(e) => {
											e.preventDefault()
											this.setState({ isActionFormShown: true, selectedComplainAction: null })
										}}
									>
										<i className='mdi mdi-file-plus'/> New Form
									</button>
								</Row>
							}
							<Row style={{ marginTop: 50 }}>
								{ (complainActions.length == 0) && <Empty/> }
								{
									(complainActions.length > 0) &&
									<Timeline mode="alternate">
										{
											complainActions.map((complainAction, key) => {
												
												return (
													<Timeline.Item key={key}>
														<Row>
															<h4>{complainAction.status}</h4>
														</Row>
														<Row>
															<span style={{ fontSize: 16, color: 'gray' }}>
																{moment(complainAction.action_date).format('lll')}
															</span>
														</Row>
														<Row style={{ marginTop: 20 }}>
															<i className='complain-remarks'>{complainAction.action_remarks || complainAction.lupon_member_name}</i>
														</Row>
														<Row>
															<a onClick={() => this.setState({ isViewActionShown: true, selectedComplainAction: complainAction })} href='javascript:void(0)'>View</a>
															<a onClick={() => {
																this.setState({ isActionFormShown: true, selectedComplainAction: complainAction })
															}} style={{ marginLeft: 10 }} href='javascript:void(0)'>Edit</a>
															{
																isAdmin &&
																<Popconfirm
																	title="Are you sure delete this complain action?"
																	onConfirm={() => {
																		const { deleteComplainAction } = this.props
																		deleteComplainAction({ complain_action_uid: complainAction.uid })
																			.then((response) => {
																				message.success('Complain successfully deleted.')

																				//create audit trail
																				const auditParams = {
																					module_name: 'Complain Action',
																					action: 'Delete',
																					message: `Deleted complain action ${complainAction.status}`
																				}
																				AuthStore.saveAuditTrail(auditParams)
																			}).catch(err => {
																				console.log('error deleting complain', err)
																				message.error(err.message.replace('GraphQL error:', ''))
																			})
																	}}
																	// onCancel={cancel}
																	okText="Yes"
																	cancelText="No"
																>
																	<a style={{ marginLeft: 10 }} href="javascript:void(0)" >Delete</a>
																</Popconfirm>
															}
														</Row>
													</Timeline.Item>
												)
											})
										}
									</Timeline>
								}
							</Row>

							{
								isActionFormShown &&
                                <AddActionForm 
                                	selectedComplainAction={selectedComplainAction}
                                	complain_uid={complain_uid}
                                	visible={isActionFormShown}
                                	onClose={() => this.setState({ isActionFormShown: false })}
                                />
							}
							{
								isViewActionShown &&
								<ViewAction 
									file_url={selectedComplainAction.file_url}
									visible={isViewActionShown}
									onCancel={() => this.setState({ isViewActionShown: false, selectedComplainAction: null })}
								/>
							}
						</Row>
					)
				}}
			</Query>
		)
	}
    
    
}

const COMPLAIN_ACTIONS = gql`
    query barangayComplainActions($complain_uid: String) {
		barangayComplainActions(complain_uid: $complain_uid)
    }
`

const DELETE_COMPLAIN_ACTION = gql`
    mutation deleteComplainAction($input: JSON) {
		deleteComplainAction(input: $input)
    }
`

const composed = compose(
	withRouter,
	inject('AuthStore'),
	graphql(DELETE_COMPLAIN_ACTION, {
		props({ mutate }) {
			return {
				deleteComplainAction(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['barangayComplains','barangayComplainByUid','barangayComplainActions']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)